import React, { FC } from 'react';
import logo from 'assets/logo.png';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';

const DenthubLogo: FC = () => {
    return (
        <Box display="flex" width="100%">
            <Link to="/orders/list" data-test="denthub-logo-link">
                <Box display="flex" alignItems="center">
                    <img
                        src={logo}
                        style={{
                            height: 30,
                            marginRight: 10,
                        }}
                    />
                </Box>
            </Link>
        </Box>
    );
};

export default DenthubLogo;
